import { getToken } from "firebase/messaging";
import { initFirebase } from "./firebase";
import API from "../api/deliveryApi";

export const registerDeliveryNotification = async(deliveryBoyId) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            return;
        }

        // ✅ Destructure config from initFirebase
        const { messaging, vapidKey, config } = await initFirebase();
        if (!messaging || !vapidKey) throw new Error("Firebase failed to initialize properly");

        // ✅ Convert config to URL query string
        const queryParams = new URLSearchParams(config).toString();

        // ✅ REGISTER SERVICE WORKER with dynamic credentials in the URL
        const registration = await navigator.serviceWorker.register(
            `/firebase-messaging-sw.js?${queryParams}`
        );

        await navigator.serviceWorker.ready;

        // ✅ GET FCM TOKEN
        const token = await getToken(messaging, {
            vapidKey: vapidKey, // Pulled securely from the backend
            serviceWorkerRegistration: registration
        });

        if (token) {
            // ✅ SAVE TOKEN
            await API.post("/notifications/save-token", {
                user_id: deliveryBoyId,
                role: "DELIVERY_BOY",
                token: token
            });
        }
    } catch (err) {
        console.error("DELIVERY NOTIFICATION ERROR:", err);
    }
};